import { Theme } from "@mui/material/styles";

const barHeight = 45;

export default function AppBar(theme: Theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }: any) => ({
          borderRadius: "unset",
          background: "white",
          boxShadow: "0px 8px 100px rgba(0, 0, 0, 0.1)",
        }),
      },
    },
  };
}
